import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { UploadAttachmentService } from 'src/app/services/upload-attachment.service';
import { ApiConstants } from 'src/app/base/api-constants';

import { TranslateService } from '@ngx-translate/core';
import { v4 as uuidv4 } from 'uuid';
import { IconType } from 'src/app/services/util.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'vb-icon-selector',
  templateUrl: './icon-selector.component.html',
  styleUrls: ['./icon-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IconSelectorComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: false  //NOSONAR
})
export class IconSelectorComponent implements OnInit {
  private confirmationDialogService = inject(ConfirmationDialogService);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private uploadService = inject(UploadAttachmentService);
  private appGlobalService = inject(AppGlobalService);
  private translateService = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  @Input() element: any;
  @Input() disableField: any = false;
  @Input() curNode: string;
  private modelValue: any;
  private onChange: (m: any) => void = () => { /* noop */ };
  private onTouched: (m: any) => void = () => { /* noop */ };
  private iconGroupsData: any[] = [];
  private scrollTicking = false;
  searchTerm: any;

  filteredIconGroups: any[] = [];
  activeCategory = '';
  @ViewChild('iconScrollContainer') iconScrollContainer: ElementRef;
  @ViewChild('categorySidebar') categorySidebar: ElementRef;
  disabled: boolean;
  orgId: any = null;
  appId: any = null;
  iconType: string = IconType.SYSTEM_ICON;
  iconColor = '#000000';
  @Input() iconSize = '13px';
  selectedIcon: any = null;
  imageLoading = false;
  backupType: string = IconType.SYSTEM_ICON;
  value: any = null;
  backupValue: any = null;
  selectedImageSrc = null;
  showIconSelectorPopUp: boolean;
  isHomePageImageSelection = false;
  fileId:any = null;
  fileTargetResult: any = null;

  /**
   * Checks if the current node is a menu item or menu group.
   * For these elements, icon removal is not allowed - at least one icon must be present.
   */
  get isMenuElement(): boolean {
    const nodeType = this.curNode?.toLowerCase() || '';
    return ['menuitem', 'menu_item', 'menugroup', 'menu_group'].includes(nodeType);
  }

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setValueToIcon(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  getSvgPath(iconValue: string): string {
    return `assets/designIconLib/SVG/${iconValue.endsWith('.svg') ? iconValue : iconValue + '.svg'}`;
  }

  onIconUpload(event: any, control: any, property?: any) {
    this.iconType = IconType.UPLOADED;
    const file = event?.target?.files[0];
    if (!file) return;
    const reader: any = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e: any) => {
      $(`#${control}_img`).attr('src', e.target.result);
      this.fileTargetResult = e.target.result;
      $(`#${control}_label`).text(file.name);
    };

    const curFile: any = file;
    curFile['fieldName'] = control;
    this.appGlobalService.write('fileUpload', file);
    this.fileId = this.fileId ? this.fileId : uuidv4();
    this.modelValue = {
      type: this.iconType,
      icon: [{
        id: this.fileId,
        fileName: curFile.name
      }]
    };
  }

  setValueToForm(value) {
    if (value) {
      this.modelValue = value;
      this.backupType = this.iconType;
      if (value.icon && ((Array.isArray(value.icon) && value.icon.length) || Object.keys(value.icon).length)) {
        this.value = value;
      }
    } else {
      this.modelValue = null;
      this.value = null;
    }
    this.onChange(this.modelValue);
  }

  createImageFromBlob(image: Blob, icon: any) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        const imageToShow: any = reader.result;
        $(`#${this.element.name}_img`).attr('src', imageToShow);
        $(`#${this.element.name}_img_display`).attr('src', imageToShow);
        $(`#${this.element.name}_label`).text(icon[0]?.fileName);
        this.selectedImageSrc = imageToShow;
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
    this.imageLoading = false;
  }

  setImage(api, icon) {
    this.uploadService.downloadFile(api).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        const fileType = icon[0]?.fileName?.split('.')[1];
        let newData = data;
        if (fileType === 'svg') {
          newData = newData.slice(0, newData.size, 'image/svg+xml');
        }
        this.createImageFromBlob(newData, icon);
      },
      error: () => {
        this.imageLoading = false;
      }
    });
  }

  getImages(icon: any) {
    const file = icon?.[0]?.id;
    this.fileId = file;
    const api = `${ApiConstants.getFileContents.url + file}/${this.appGlobalService.get('appId')}`;
    this.imageLoading = true;
    this.setImage(api, icon);
  }

  setValueToIcon(value) {
    if (value) {
      this.iconType = value.type;
      this.backupType = this.iconType;
      if (value?.icon?.[0]?.fileName) {
        // console.log('uploaded: ', value?.icon?.[0]?.fileName);
        this.getImages(value?.icon);
      } else if (value?.icon?.value) {
        this.selectedIcon = { ...value.icon };
        this.iconColor = value.iconColor;
        this.iconSize = value.iconSize;
      }
      if ((value?.icon && Array.isArray(value?.icon) && value?.icon.length) || Object.keys(value?.icon).length) {
        this.value = value;
      }
    }
  }

  triggerClearValueConfirmation(element: any) {
    this.iconAndImageRemovalConfirmation(() => this.clearValue(), element.title);
  }

  iconAndImageRemovalConfirmation(callback: () => void, element: string) {
    const confirmDeleteCallback = () => {
      callback();
    };
    this.confirmationDialogService.confirm({
      message: this.translateService.instant('DELETE_CONFIRMATION_ICON', { title: element }),
      header: 'Confirmation',
      accept: confirmDeleteCallback,
      reject: () => {
        return;
      }
    });
  }

  clearValue() {
    if (this.iconType === IconType.UPLOADED) {
      this.fileId = null;
    }
    this.iconType = IconType.SYSTEM_ICON;
    this.backupType = '';
    this.setValueToForm(null);
  }

  removeSelectedImg() {
    this.confirmationDialogService.confirm({
      message: 'Are you sure that you want to delete?',
      header: 'Confirmation',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.selectedIcon = null;
        this.iconType = IconType.SYSTEM_ICON;
        this.backupType = '';
        this.modelValue = null;
        $(`#${this.element.name}_img`).removeAttr('src');
        $(`#${this.element.name}_img_display`).removeAttr('src');
        $(`#${this.element.name}_label`).text('');
      },
      reject: () => {
        console.log('rejected');
      }
    });
  }

  saveSelectedIcon() {
    if (this.iconType === IconType.SYSTEM_ICON) {
      this.setValueToForm({
        icon: this.selectedIcon,
        iconColor: this.iconColor,
        iconSize: this.iconSize,
        type: IconType.SYSTEM_ICON
      });
    } else if (this.iconType === IconType.UPLOADED) {
      this.setValueToForm(this.modelValue);
      setTimeout(() => {
        if (this.fileTargetResult) {
          $(`#${this.element.name}_img_display`).attr('src', this.fileTargetResult);
        }
      }, 100);
    }
    this.closePopup();
  }

  async showPanel() {
    this.showIconSelectorPopUp = true;
    await this.loadIconData();
    this.filteredIconGroups = this.iconGroupsData.map((g: any) => ({ ...g }));
    this.activeCategory = this.filteredIconGroups[0]?.category || '';
    this.backupValue = this.selectedIcon;
    if (this.value?.icon && this.iconType === IconType.SYSTEM_ICON) {
      this.selectedIcon = this.value.icon;
      if (this.value.iconSize) {
        this.iconSize = this.value.iconSize;
      }
    }
    if (this.iconType === IconType.UPLOADED && this.selectedImageSrc) {
      setTimeout(() => {
        $(`#${this.element.name}_img`).attr('src', this.selectedImageSrc);
        $(`#${this.element.name}_label`).text(this.value?.icon[0]?.fileName);
      }, 100);
    }
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.orgId = this.appGlobalService.get('orgId');
    this.appId = this.appGlobalService.get('appId');
    if (this.curNode?.toLowerCase() === 'homepage' && this.element?.id?.toLowerCase() === 'backgroundimage') {
      this.isHomePageImageSelection = true;
    }
  }

  isIconDirty(): boolean {
    if (!this.selectedIcon && !this.backupValue) {
      return false;
    }
    if (!this.selectedIcon || !this.backupValue) {
      return true;
    }
    return JSON.stringify(this.selectedIcon) !== JSON.stringify(this.backupValue);
  }

  confirmClosePopup() {
    if (this.isIconDirty()) {
      this.confirmationDialogService.confirm({
        message: this.translateService.instant('UNSAVED_CHANGES_CONFIRM'),
        header: 'Confirmation',
        accept: () => this.closePopup(),
        reject: () => {
          console.log('rejected');
        }
      });
    } else {
      this.closePopup();
    }
  }

  closePopup() {
    this.iconSize = '13px';
    this.showIconSelectorPopUp = false;
  }
  selectIcon(icon) {
    this.selectedIcon = icon;
    this.iconType = IconType.SYSTEM_ICON;
  }

  scrollToCategory(category: string) {
    this.activeCategory = category;
    const container = this.iconScrollContainer?.nativeElement;
    if (!container) return;
    const el = container.querySelector(`[data-category="${category}"]`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  onIconScroll() {
    if (this.scrollTicking) return;
    this.scrollTicking = true;
    requestAnimationFrame(() => {
      this.updateActiveCategory();
      this.scrollTicking = false;
    });
  }

  private updateActiveCategory() {
    const container = this.iconScrollContainer?.nativeElement;
    if (!container) return;
    const groups = container.querySelectorAll('[data-category]');
    const scrollTop = container.scrollTop;
    let current = '';
    groups.forEach((el: HTMLElement) => {
      if (el.offsetTop - container.offsetTop <= scrollTop + 40) {
        current = el.dataset.category || '';
      }
    });
    if (current && current !== this.activeCategory) {
      this.activeCategory = current;
      this.scrollCategorySidebarToActive(current);
    }
  }

  private scrollCategorySidebarToActive(category: string) {
    const sidebar = this.categorySidebar?.nativeElement;
    if (!sidebar) return;
    const activeItem = sidebar.querySelector(`[data-sidebar-category="${category}"]`) as HTMLElement;
    if (activeItem) {
      const sidebarRect = sidebar.getBoundingClientRect();
      const itemRect = activeItem.getBoundingClientRect();
      // Check if item is outside visible area of sidebar
      if (itemRect.top < sidebarRect.top || itemRect.bottom > sidebarRect.bottom) {
        activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  filterIcon() {
    const query = this.searchTerm ? this.searchTerm.toLowerCase() : '';
    this.filteredIconGroups = this.iconGroupsData
      .map((g: any) => ({
        ...g,
        icons: g.icons.filter((ic: any) => ic.value.indexOf(query) > -1)
      }))
      .filter((g: any) => g.icons.length > 0);
    this.activeCategory = this.filteredIconGroups[0]?.category || '';
  }

  trackByCategory(_index: number, group: any): string {
    return group.category;
  }

  trackByIcon(_index: number, icon: any): string {
    return icon.value;
  }

  private async loadIconData(): Promise<void> {
    if (this.iconGroupsData.length) return;
    const module = await import('src/assets/sampleData/designIconLib.icons.json');
    this.iconGroupsData = (module as any).default || module;
  }

  isFontAwesomeIcon(icon: any): boolean {
    return icon?.startsWith('fas fa-') || icon?.startsWith('fa fa-');
  }
}



